/*
 *
 *  VeeValidate
 */

// deps
import { configure } from 'vee-validate'
import { localize } from 'vee-validate'
import { extend } from 'vee-validate'
import { alpha, required, email, numeric, min, max } from 'vee-validate/dist/rules'

// configure
configure({
  mode: 'aggressive',
  delay: 500,
  bails: true,
  skipOptional: true,
  useConstraintAttrs: true
})

// localize
localize('ar')

// required
extend('alpha', {
  ...alpha,
  message: 'يجب أن تكون أحرفاً فقط'
})

// required
extend('required', {
  ...required,
  message: 'هذا الحقل مطلوب'
})

// email
extend('email', {
  ...email,
  message: 'الإيميل يجب أن يكون بريداً إليكتروناً صحيحاً'
})

// numeric
extend('numeric', {
  ...numeric,
  message: 'القيمة يجب أن تكون أرقاماً فقط'
})

// min
extend('min', {
  ...min,
  message: 'يجب أن لا تقل القيمة عن {length} أحرف/أرقام'
})

// max
extend('max', {
  ...max,
  message: 'يجب أن لا تزود القيمة عن {length} أحرف/أرقام'
})
